import React,{useState,useEffect} from "react";
import {Modal} from 'antd'
import Slider from "@ant-design/react-slick";
import SlideImage from "./SideImage";
function MediaContent({service,province,Medias}){
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [slideImages, setSlideImages] = useState([]);

    const showModal = (item) => {
        setIsModalVisible(true);
        const array = Medias.filter(a=>a.id==item)
        setSlideImages(array);
    };
    
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    
    
    

    return(
        <>
        <div className="mediaContent">
            <div className="container">
                <div className="row">
                    {Medias
                    .filter(media=>(province=="all"||province==null || media.province_code===province)&&
                    (service=="all"||service==null || media.service_code===service))
                    .map((item,index)=>{
                        return(
                            <>
                        <div className="col-lg-6 col-12 col-md-6" key={index} onClick={() => showModal(item.id)}>
                        <div className="itemBox">
                            <div className="image">
                                <img className="img-fluid" src={item.avatar} alt="" />
                            </div>
                            <div className="title">
                                    {item.title}
                            </div>
                        </div>
                        
                    </div>
                    </>)
                    })}
                </div>
            </div>
        </div>
        {
                slideImages && slideImages.map(item=>{
                    return(
                       <Modal className="modalMedia" title={""} footer={false} visible={isModalVisible} width={900}  onCancel={handleCancel}>
                            <SlideImage img={item.image} />
                        </Modal>
                    )
                })
            }
        
        </>
    )
}
export default MediaContent;